
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { cloneDeep } from 'lodash'

export default {
    name: 'AccessControlRuleDialog',
    components: { DialogTemplate },
    props: {
        props: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            reader: cloneDeep(this.props.reader),
        }
    },
    methods: {
        saveChanges() {
            return this.$emit('close')
        },
    },
}
